export enum CancellationReasonVisibilitiesType {
  Admin = "Admin",
  Agent = "Agent"
}
